import { render } from "./Upload.vue?vue&type=template&id=7205bea8"
import script from "./Upload.vue?vue&type=script&lang=js"
export * from "./Upload.vue?vue&type=script&lang=js"
script.render = render

export default script